import { useMemo } from 'react';
import SvgIcon from 'components/SvgIcon';
import './circular-logo.scss';

type Props = {
  logo: string | undefined;
  name: string | undefined;
  logoAllowed?: boolean;
  className?: string;
  size?: number;
  wrap?: boolean;
  wrapperClass?: string;
};

const CircularLogo = ({ logo, name, size, logoAllowed = true, wrap = true, className = '', wrapperClass = '' }: Props) => {
  const nameSplit = useMemo(() => name ? name.toUpperCase().split(' ') : [], [name]);

  const classNames = className ? [className] : [];
  if (!logo || !logoAllowed) classNames.push('letters-only');
  if (size !== undefined && size < 50) classNames.push('letters-small');

  const logoElement = (
    <div className={`circular-logo-container ${classNames.join(' ')}`.trim()} style={size ? { width: size, height: size } : undefined}>
      {logo || name ?
        <>
          {logo && logoAllowed
            ? <img className="circular-logo" alt={logo ? logo.split("/").pop()?.split(".").slice(0, -1).join(".") : ''} src={logo} />
            : <div className={`circular-logo-letters ${!logoAllowed ? 'logo-not-allowed' : ''}`.trim()}>{nameSplit[0][0]} {nameSplit.length > 1 && nameSplit[1][0]}</div>
          }
        </>
        :
        <SvgIcon className="logo-no-logo-no-text" name="logo-no-text" />
      }
    </div>
  );

  return wrap ? (
    <div className={`logo-wrapper ${wrapperClass}`.trim()}>
      {logoElement}
    </div>
  ) : (
    logoElement
  );
};

export default CircularLogo;
